import mutations from './moduleDonationsMutations.js'
import actions from './moduleDonationsActions.js'
import getters from './moduleDonationsGetters.js'

const getDefaultState = () => {
  return {
    lastUpdate: 0,
    donationsState: null,//null, loading, ready
    donations: [],
  }
}

export default {
  isRegistered: false,
  namespaced: true,
  state: getDefaultState(),
  mutations: {
    ...mutations,
    RESET_STATE(state) {
      Object.assign(state, getDefaultState())
    }
  },
  actions,
  getters
}

